import type { components } from "@/services/customer-schema";
import { faker } from "@faker-js/faker";
import { accountBases } from "./accounts.mock";

faker.seed(0);

const numSegregated = 3;
const numAggregated = 17;
const totalAddresses = numAggregated + numSegregated + numSegregated;

type CustomAddress = components["schemas"]["CustodyAddress"];

const segregatedAddresses: CustomAddress[] = [
  ...Array(numSegregated).fill(accountBases[1]),
  ...Array(numSegregated).fill(accountBases[2]),
].map((accountBase) => {
  const asset = faker.helpers.arrayElement([
    "USDC",
    "BTC",
    "BTC",
    "ETH",
    "USDT",
    "SOL",
  ]);
  let network;
  let address;

  if (asset === "BTC") {
    network = "BITCOIN";
    address = faker.finance.bitcoinAddress({ type: "bech32" });
  } else if (asset === "SOL") {
    network = "SOLANA";
    address = faker.string.alphanumeric(44); // fake a Solana-style address
  } else {
    network = "ETHEREUM";
    address = faker.finance.ethereumAddress();
  }

  return {
    id: faker.string.numeric(3),
    account: {
      id: accountBase.id,
      name: accountBase.name,
      type: "SEGREGATED",
    },
    label: faker.string.alpha(6),
    requestedAt: faker.date.past().toUTCString(),
    blockchain: network,
    clientReference: "my old style test ref",
    address: address,
    requestedBy: {
      id: faker.string.numeric(5),
      username: faker.person.fullName(),
    },
  };
});

const aggregatedAddresses: CustomAddress[] = [...Array(numAggregated)].map(
  () => {
    const asset = faker.helpers.arrayElement([
      "USDC",
      "BTC",
      "BTC",
      "ETH",
      "USDT",
      "SOL",
    ]);
    let network;
    let address;

    if (asset === "BTC") {
      network = "BITCOIN";
      address = faker.finance.bitcoinAddress({ type: "bech32" });
    } else if (asset === "SOL") {
      network = "SOLANA";
      address = faker.finance.litecoinAddress();
    } else {
      network = "ETHEREUM";
      address = faker.finance.ethereumAddress();
    }

    return {
      id: faker.string.numeric(3),
      account: {
        id: faker.helpers.arrayElement([accountBases[0], accountBases[3]]).id,
        name: faker.helpers.arrayElement([accountBases[0], accountBases[3]])
          .name,
        type: "AGGREGATED",
      },
      label: faker.string.alpha(6),
      requestedAt: faker.date.past().toUTCString(),
      blockchain: network,
      clientReference: faker.string.numeric(10),
      address: address,
      requestedBy: {
        id: faker.string.numeric(5),
        username: faker.person.fullName(),
      },
    };
  },
);

const shuffledAddresses = faker.helpers.arrayElements(
  [...segregatedAddresses, ...aggregatedAddresses],
  { min: totalAddresses, max: totalAddresses },
);

export const depositAddress: components["schemas"]["CustodyAddress"] =
  aggregatedAddresses[0]; // TO-DO: update to find the address by id

export const depositAddresses: components["schemas"]["CustodyAddresses"] = {
  addresses: shuffledAddresses,
  pagination: {
    limit: 10,
    firstCursor: "abc123",
    nextCursor: "def456",
    lastCursor: "def456",
  },
};
